var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicNotVaild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2498 2.16699C14.8691 2.16699 13.7498 3.28628 13.7498 4.66699C13.7498 6.04771 14.8691 7.16699 16.2498 7.16699H24.5832C25.9638 7.16699 27.0832 6.04771 27.0832 4.66699C27.0832 3.28628 25.9638 2.16699 24.5832 2.16699H16.2498ZM15.4165 10.5003C12.6551 10.5003 10.4165 8.26174 10.4165 5.50033V4.54794C10.4165 4.15346 10.0967 3.83366 9.70225 3.83366C7.33529 3.83366 5.4165 5.75246 5.4165 8.11941L5.41654 33.8337C5.41654 36.5952 7.6551 38.8337 10.4165 38.8337H30.4165C33.178 38.8337 35.4165 36.5952 35.4165 33.8337V8.13461C35.4165 5.75931 33.4908 3.83381 31.1155 3.83399C30.7197 3.83403 30.3988 4.15493 30.3988 4.55078V5.55174C30.3707 8.29296 28.1405 10.5003 25.3992 10.5003H15.4165ZM15.0713 25.9885C14.4205 26.6393 14.4205 27.6947 15.0713 28.3455C15.7222 28.9963 16.7775 28.9963 17.4283 28.3455L20.4165 25.3573L23.4047 28.3455C24.0555 28.9963 25.1108 28.9963 25.7617 28.3455C26.4125 27.6947 26.4125 26.6393 25.7617 25.9885L22.7735 23.0003L25.7617 20.0122C26.4125 19.3613 26.4125 18.306 25.7617 17.6552C25.1108 17.0043 24.0555 17.0043 23.4047 17.6552L20.4165 20.6433L17.4283 17.6552C16.7775 17.0043 15.7222 17.0043 15.0713 17.6552C14.4205 18.306 14.4205 19.3613 15.0713 20.0122L18.0595 23.0003L15.0713 25.9885Z",
    fill: "#73007D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicNotVaild);
export default __webpack_public_path__ + "static/media/mic_not_vaild.7ece1541b1ff4893fde9b86378d29668.svg";
export { ForwardRef as ReactComponent };